import { render } from "./DescriptionGroupeActivites.vue?vue&type=template&id=20793043&scoped=true"
import script from "./DescriptionGroupeActivites.vue?vue&type=script&lang=js"
export * from "./DescriptionGroupeActivites.vue?vue&type=script&lang=js"

import "./DescriptionGroupeActivites.vue?vue&type=style&index=0&id=20793043&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20793043"]])

export default __exports__